import { AfterViewInit, ChangeDetectorRef, Component } from "@angular/core";
import { Fiat, PriceAlert } from "@models";
import { SegmentService } from "@main-services/segment.service";
import { PriceAlertService } from "@main-services/price-alert.service";
import { FiatService } from "@main-services/currency/fiat.service";
import { AccountService } from "@modules/account/services/account.service";
import { TradableListService } from "@main-services/currency/tradable_list.service";
import { Tradable } from "@models/interfaces/tradable";
import { BpModalHasSave } from "@models/interfaces/bp-modal-has-save";
import { stripFunnyInput } from "@helpers/utils";
import { CustomModal } from "@modules/core/components/base-modals";
import { MasterdataService } from "@core-services/masterdata.service";
import { InfoService } from "@core-services/info.service";
import { RudderstackService } from "@main-services/rudderstack.service";

@Component({
	templateUrl: "./pricewatch-add-modal.component.html",
	styleUrls: ["./pricewatch-add-modal.component.scss"],
	standalone: false
})
export class PricewatchAddModalComponent extends CustomModal implements AfterViewInit, BpModalHasSave {
	public constructor(
		private infoService: InfoService,
		private masterdataService: MasterdataService,
		private tradableListService: TradableListService,
		private fiatService: FiatService,
		private accountService: AccountService,
		private ref: ChangeDetectorRef,
		private priceAlertService: PriceAlertService,
		private segmentService: SegmentService,
		private rudderstackService: RudderstackService
	) {
		super();
	}

	public data: PriceAlert = null;
	public priceButtons: string[] = ["-10", "-5", "+5", "+10"];
	private amountSet: number = 0;
	private midSave: string = "";

	public save(): void {
		if (this.data.getAmount() <= 0) {
			this.infoService.setError(this.translationService.translate("amount_has_to_be_above_0"));
		} else {
			this.priceAlertService.add(this.data).subscribe(() => this.close());
		}
	}

	public ngAfterViewInit(): void {
		this.data._amount = "" + this.transformToFiatDisplayFormat(this.getAvgPrice());
		this.midSave = this.data._amount;

		this.segmentService.page({
			name: "Create Alert",
			overridePath: "/alert"
		});
		this.rudderstackService.page({
			name: "Create Alert",
			overridePath: "/alert"
		});
	}

	public setNewAvgAmount(): void {
		this.amount = this.transformToFiatDisplayFormat(this.getAvgPrice());
		this.midSave = this.amount;
	}

	public get fiat(): Fiat {
		return this.accountService.getDefaultFiat();
	}

	public get fiatSymbol(): string {
		if (this.data) {
			return this.fiatService.getItemById(this.data.getFiatId()).getSymbol();
		}
		return "";
	}

	public get tradable(): Tradable {
		return this.tradableListService.getItemById(this.data.getCurrencyId());
	}

	public set tradable(tradable: Tradable) {
		if (tradable.getId() === this.data.getCurrencyId()) {
			return;
		}
		this.data.setCurrencyId(tradable.getId());
		this.killInput();
	}

	public get amount(): string {
		return this.data._amount;
	}

	public adjustPriceAlert(percentage: string): void {
		this.amountSet++;

		if (this.midSave.substring(0, this.amount.length) !== this.amount) {
			this.midSave = this.amount;
		}

		if (percentage.startsWith("+")) {
			this.midSave = (+this.midSave * (100 + +percentage.substring(1, percentage.length))) / 100 + "";
		} else {
			this.midSave = (+this.midSave * (100 - +percentage.substring(1, percentage.length))) / 100 + "";
		}
		this.amount = this.transformToFiatDisplayFormat(+this.midSave);
	}

	public set amount(s: string) {
		this.amountSet++;
		if (this.amountSet >= 4) {
			this.data._amount = stripFunnyInput(s);
		}
	}

	public getAvgPrice(): number {
		return this.masterdataService.euroToDefault(this.tradable.getAvgPrice(), this.fiat);
	}

	/** This is ugly as heck but it works **/
	public show: boolean = true;

	public killInput(): void {
		this.show = false;
		this.setNewAvgAmount();
	}

	public restoreInput(): boolean {
		this.show = true;
		this.ref.detectChanges();
		return false;
	}

	/** Pls kill me for this **/

	private transformToFiatDisplayFormat(value: number): string {
		return value.toFixed(this.tradable.getPrecisionFiat());
	}
}
